import React from 'react';
import ProgressBar from '../ProgressBar';

const PHRASES_EARLY = [
  'Опять работать?!',
  'Процесс пошёл, жди',
  'Ну вот тебе точно заняться нечем, кроме работы, да?',
  'Шо? Опять?',
  'И снова здравствуйте',
];
const PHRASES_MID = [
  'Да ща-ща, бля буду',
  'Сложна...',
  'Терпение! Не надо смотерть пока я работаю!',
  'Почти готово... наверное',
  'Да думаю я, думаю! Сидит тут понимаешь..',
  'Ещё чуть-чуть и может получится',
];
const PHRASES_LATE = [
  'Дэээ, че за жесть ты там скинула?',
  'Война и мир?',
  'Сидели двое..',
  'Можешь пока чаёк заварить',
];
const PHRASES_VERY_LATE = [
  'Хуй знает че так долго, но жди че еще тебе остается',
  'Можешь кофейку бахнуть',
  'Сходи покури',
  'Значит заходит юрист в бар..',
  'Если это не закончится, я начну петь',
  'Катку в Hearthstone точно бы успела',
];

function getPhrase(loadingTime: number, seed: number): string {
  const phrases =
    loadingTime < 60  ? PHRASES_EARLY :
    loadingTime < 120 ? PHRASES_MID :
    loadingTime < 180 ? PHRASES_LATE :
    PHRASES_VERY_LATE;
  return phrases[seed % phrases.length];
}

interface Props {
  loadingTime: number;
  isBackendDead: boolean;
  phraseSeed: number;
}

export default function LoadingState({ loadingTime, isBackendDead, phraseSeed }: Props) {
  return (
    <div className="mt-3">
      <div className="max-w-md mx-auto mb-2">
        <ProgressBar />
      </div>

      {loadingTime >= 1 && (
        <p className="text-xs text-pink-400 italic text-center">
          {getPhrase(loadingTime, phraseSeed)}
        </p>
      )}

      {isBackendDead && (
        <p className="text-sm text-red-600 font-medium animate-pulse mt-2 text-center">
          Бэкенд не отвечает! Возможно он упал.
        </p>
      )}

      <div className="mt-6 flex justify-center">
        <img
          src="/mashulya.gif"
          alt="Ожидание..."
          loading="lazy"
          style={{ maxWidth: '300px', borderRadius: '16px' }}
        />
      </div>
    </div>
  );
}
